<template>
  <div>
    <PCNavbar selectIndex="8"/>
    <MobileNavBar :currentActive="7" />
    <AiSearch/>
    <router-view></router-view>
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import AiSearch from '@/components/ai-search/index.vue'
export default {
  components: {
    PCNavbar,
    MobileNavBar,
    AiSearch
  },
}
</script>

<style>
.el-timeline-item__timestamp{
  font-size: 0.9rem !important;
  padding: 1rem 0;
}
</style>